import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@pg-env/environment';
import { Observable } from 'rxjs';

interface IInfoCode {
  verificationCode?: string;
  userId: string;
  clientId?: string;
  portalId: string;
  verificationType?: Number;
  tokenHash?: string;
}
interface IUserPhoneNumber {
  phoneNumber: string;
  userId: string;
  clientId: string;
  tokenHash: string;
  customerType: string;
}

interface IConfirmAccountRegistration {
  tokenHash: string;
}

interface IEmailNotArrive {
  email: string;
  clientId: string;
}

@Injectable({
  providedIn: 'root'
})
export class RegisterStep1Service {
  baseUrl = environment.identityApiUrl;
  customerApiUrl = environment.customerApiUrl;
  crmIntegrationApiUrl = environment.crmIntegrationApiUrl;
  identityApiUrl = environment.identityApiUrl;

  constructor(protected http: HttpClient) {}

  verifyCode(info: IInfoCode): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/account/login-verify-code`, info);
  }

  resendPassCode(params): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/register-account-send-verification-code`, params);
  }

  confirmAccountRegistration(confirmAccountRegistration: IConfirmAccountRegistration): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/confirm-account-registration`, confirmAccountRegistration, {
      headers: {
        useLocalHandleException: 'Y'
      }
    });
  }

  addPhonenumber(userPhoneNumber: IUserPhoneNumber): Observable<any> {
    return this.http.put<any>(`${this.baseUrl}/account/add-user-phone-number`, userPhoneNumber);
  }

  public submitIndividualForm(privateAccountInfo: any): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/register-account`, privateAccountInfo);
  }

  public emailNotArrive(emailNotArrive: IEmailNotArrive): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/email-did-not-arrive`, emailNotArrive);
  }

  public getRegisterInfo(token: string): Observable<any> {
    const encodeToken = encodeURIComponent(token);
    return this.http.get(`${this.baseUrl}/account/get-account-info-by-token?token=${encodeToken}`);
  }

  public getRegisterInfo2(id: string): Observable<any> {
    return this.http.get(`${this.customerApiUrl}/customer/get-organization-by-partnerid/${id}`);
  }

  public checkEmailExist(param): Observable<any> {
    return this.http.post(`${this.crmIntegrationApiUrl}/account/Check-Email-CRM`, param);
  }

  public retrieveCompanyProfile(body: Object): Observable<any> {
    return this.http.post(`${this.customerApiUrl}/passfort/retrieve-company-profile`, body);
  }

  public searchCompanyProfile(body: Object): Observable<any> {
    return this.http.post(`${this.customerApiUrl}/passfort/search-company-profile`, body);
  }

  public getPartnerResidency(): Observable<any> {
    return this.http.get(`${this.customerApiUrl}/customer/get-partner-residency`);
  }

  public validateToken(params): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/validate-token`, params);
  }

  public verifyRecaptcha(param): Observable<any> {
    return this.http.post(`${this.baseUrl}/account/verify-recaptcha`, param);
  }

  public isEmailValid(param): Observable<any> {
    return this.http.post(`${this.customerApiUrl}/customer/validate-email`, param);
  }

  public sendExistingAccountRegistrationNotification(param): Observable<any> {
    return this.http.post(`${this.identityApiUrl}/account/send-existing-account-registration-notification`, param);
  }
}
